export default {
  allMsg: '所有消息',
  systemMsg: '系统消息',
  personMsg: '人工消息',
  unread: '未读',
  seeDetail: '查看详情',
  read: '已读',
  replyNow: '现在回复',
  message: '站内信',
  operateSuccess: '操作成功',
  holder: {
    searchHolder: '包裹号/订单号/商品编号',
  },
  addAcBuy: '加入AcBuy Discord，赢取¥2000现金大奖！',
  joinNow: '点击这里加入',
  flatActivity: 'Acbuy 黑五大促',
  joinNow1: '立即加入',
  tips1: '享受高达 70% 折扣',
  tips2: '输入代码即可立即领取 ¥110 运费优惠券！',
}
